import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Header() {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const isActive = (path: string) => {
    return location.pathname === path ? 'text-[#8B5CF6]' : 'text-gray-600 hover:text-gray-900';
  };

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr');
  };

  return (
    <nav className="bg-[#101828] border-b border-gray-700 fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/">
            <img
              src="/images/zeswitch2.png"
              alt="Zeswitch"
              className="h-10 w-auto"
            />
          </Link>
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLang}
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors px-2 py-1 rounded border border-gray-600 hover:border-gray-400"
            >
              {i18n.language === 'fr' ? 'EN' : 'FR'}
            </button>
            <Link
              to="/login"
              className="inline-flex items-center justify-center px-3 sm:px-4 py-2 border border-[#8B5CF6] text-sm font-medium rounded-md text-[#8B5CF6] bg-[#121214] hover:bg-gray-800 transition-colors whitespace-nowrap"
            >
              {t('header.login')}
            </Link>
            <Link
              to="/onboarding/saas"
              className="hidden sm:inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#8B5CF6] hover:bg-[#9D72F7] transition-colors whitespace-nowrap"
            >
              {t('header.createAccount')}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
